import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AI_BOT_CONFIG, BASE_DOMAIN_URI, BASE_URI, config } from 'app/app.config';
import { BehaviorSubject } from 'rxjs';
import { AssistBotService } from 'app/components/ai-assist/assist-bot.service';

export class Media {
  file_path: string;
  file_type: number;
}


@Injectable({
  providedIn: 'root'
})
export class AILibraryService {

  baseUrl = BASE_URI.URL;

  llm_model2_url = `${AI_BOT_CONFIG.training.model2Url}`;

  RECORD_LIMIT: number = config.DEFAULT_RECORD_LIMIT;
  OFFSET: number = config.DEFAULT_OFFSET;
  private mediaContent:any = new Subject<Media>();
  elibraryBS:BehaviorSubject<any> = new BehaviorSubject({});
  currentElibrary_groupId:number=0;
  constructor(
    private http: HttpClient,private assistBotService:AssistBotService
  ) { }

  getMediaContent(): Observable<any> {
    return this.mediaContent.asObservable();
  }

  emitMediaContent(mediaFields: any) {
    setTimeout(() => {
        this.mediaContent.next(<Media>mediaFields);
    }, 300);
};

  clear(){
    this.mediaContent.next();
  }

  updateMessageRead(message: any) {
    return this.http.post(`${this.baseUrl}/chats/updateMessageRead`, message);
  };


  getIndividualStAssessment(fileId, userId){
    return this.http.get(`${this.baseUrl}/studentAssessment/${fileId}/${userId}`);
  }

  getSudentsAssessmentResult(payLoad){
    return this.http.get(`${this.baseUrl}/studentQuestionandAnswer/${payLoad.fileId}/${payLoad.userId}/${payLoad.answerId}`);
  }

  getStudentDashboard(id){
    return this.http.get(`${this.baseUrl}/student/dashboard/${id}`);
  }

  postTeacherRemark(payLoad){
    return this.http.post(`${this.baseUrl}/teacher/remark`, payLoad);
  }

  submitInteractiveQuiz(payload){
    return this.http.post(`${this.baseUrl}/submitVideoQuiz`, payload);
  }


  preHttpParams(payLoad) {
    let Params = new HttpParams();
    for (const key in payLoad) {
        if (key && (payLoad[key] || payLoad[key] === 0)) {
            Params = Params.append(key, payLoad[key]);
        }
    }
    return Params;
  }

  uploadLLMPdf(payLoad){
   let LLm_url =  this.assistBotService.GptConfiguration['LLm_url'];
     return this.http.post(LLm_url+"receive_document",payLoad);
  }

  deleteLLMPdf(llmfile_uuid:any){
    let payLoad = {
      "uuid": llmfile_uuid,
      "clientid": localStorage.getItem("company_id")
     };
    let LLm_url =  this.assistBotService.GptConfiguration['LLm_url'];
      return this.http.post(LLm_url+"delete_document",payLoad);
   }

  getSummarize(payLoad){
    // let payload = {
    //   "text":extractText,
    //   "task":"summarization"
    //   };
    // return this.http.post("https://document.canstringai.com:8443/ca-llm/multiple_task",payload);
    return this.http.post(this.llm_model2_url+  "/generalgpt/query",payLoad);
  }

  uploadSummaryPdf(payload){
    return this.http.post(BASE_DOMAIN_URI + "/pdf/upload-pdf",payload);
  }

  getllmfile(llmfile_uuid:any){

   let payload = {
    "llm_unqId":llmfile_uuid
   }
     let param = this.preHttpParams(payload)
    return this.http.get(`${this.baseUrl}`+'/chats/uniqsecureReadfile/'+llmfile_uuid,{ responseType: 'blob' });
  }


}
